// extracted by mini-css-extract-plugin
export default {"container":"link_container__ERo5E"};